import React from "react"

function IconNetworkWifi({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="network-wifi"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-network-wifi"
      {...props}
    >
      <path
        d="M11.965 17.675a1.092 1.092 0 1 1-.002 2.183 1.092 1.092 0 0 1 .002-2.183zm4.698-2.6a.655.655 0 0 1-.924.927 5.35 5.35 0 0 0-7.55 0 .655.655 0 0 1-.924-.927 6.658 6.658 0 0 1 9.398 0zm2.781-3.264.224.218-.032-.028a.655.655 0 1 1-.818 1.022l-.072-.067-.215-.207c-3.77-3.533-9.69-3.456-13.367.226a.655.655 0 1 1-.926-.925c4.184-4.19 10.924-4.27 15.206-.24zM22.6 9.139a.655.655 0 0 1-.925.926c-5.365-5.358-14.056-5.358-19.421 0a.655.655 0 1 1-.925-.926c5.876-5.87 15.395-5.87 21.271 0z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconNetworkWifi
